import {
  MANAGER_GET_TEAM_REQUESTING,
  MANAGER_GET_TEAM_SUCCESS,
  MANAGER_GET_TEAM_ERROR,
  MANAGER_GET_DASHBOARD_REQUESTING,
  MANAGER_GET_DASHBOARD_SUCCESS,
  MANAGER_SELECT_TEAM_MEMBER,
  MANAGER_CREATE_TEAM_REQUESTING,
  MANAGER_CREATE_TEAM_SUCCESS,
  MANAGER_CREATE_TEAM_ERROR,
  MANAGER_CLOSE_SNACK_MESSAGE,
  MANAGER_SELECT_TAB,
  MANAGER_SEE_USER_PROFILE_REQUESTING,
  MANAGER_SEE_USER_PROFILE_SUCCESS,
  MANAGER_SEE_USER_PROFILE_ERROR,
  MANAGER_CHANGE_FIELD,
  MANAGER_SUBMIT_COMMENT_REQUESTING,
  MANAGER_SUBMIT_COMMENT_ERROR,
  MANAGER_SUBMIT_COMMENT_SUCCESS,
  MANAGER_GET_COMMENTS_ERROR,
  MANAGER_GET_COMMENTS_SUCCESS,
  MANAGER_DELETE_COMMENT_REQUESTING,
  MANAGER_DELETE_COMMENT_SUCCESS,
  MANAGER_DELETE_COMMENT_ERROR,
  MANAGER_ON_EDIT_GOAL,
  MANAGER_SUBMIT_GOALS_ERROR,
  MANAGER_SUBMIT_GOALS_SUCCESS,
  MANAGER_MODIFY_SURVEY_REQUESTING,
  MANAGER_CREATE_SURVEY_REQUESTING,
  MANAGER_CREATE_SURVEY_SUCCESS,
  MANAGER_CREATE_SURVEY_ERROR,
  MANAGER_MODIFY_SURVEY_SUCCESS,
  MANAGER_GET_SURVEYS_REQUESTING,
  MANAGER_GET_SURVEYS_SUCCESS,
  MANAGER_GET_SURVEYS_ERROR,
  MANAGER_DELETE_SURVEY_REQUESTING,
  MANAGER_DELETE_SURVEY_ERROR,
  MANAGER_DELETE_SURVEY_SUCCESS,
  MANAGER_MODIFY_SURVEY_ERROR,
  MANAGER_GET_DASHBOARD_ERROR,
  MANAGER_SEND_NOTIFICATION_ERROR,
  MANAGER_SEND_NOTIFICATION_SUCCESS,
  MANAGER_SEND_NOTIFICATION_REQUESTING
} from "./constants";

import { AUTH_LOGOUT_SUCCESS } from "../auth/reducer";
import moment from "moment";

const initialState = {
  tabSelected: 0,
  managerSurveys: [{ survey: [{ questions: [] }] }],
  managerSurvey: {
    additionalNotes: "",
    _id: "",
    fundamentalSurvey: {
      sectionTitle: "QUESTIONS FONDAMENTALES",
      questions: [
        {
          title: `Qu’est-ce que je peux faire pour t’aider ? Pour te faire gagner du temps ?`,
          answer: ""
        },
        {
          title: `Qu’est-ce que tu aimes dans ton travail ? Qu’est-ce que tu aimerais encore plus faire/plus souvent ?`,
          answer: ""
        },
        {
          title: `Qu’est-ce que tu as le plus en tête en ce moment ? Quels sont sont tes priorités? Comment tu comptes t’y prendre pour bien les gérer ?`,
          answer: ""
        }
      ]
    },
    survey: [
      {
        sectionTitle: "I. LES COMPÉTENCES",
        questions: [
          {
            title: `Qu’as-tu pu mettre en place en faveur de ton last compétence- hors pro-activité? Comment as-tu réussi à réaliser ce défi ? Qu’est-ce que tu en retiens ? Comment feras-tu la prochaine fois ?`,
            answer: ""
          },
          {
            title:
              "Es-ce que tu te souviens de ton dernier défi en last compétence? Je le trouve pas forcément évident à mettre en place, comment tu t’y ai pris ? Comment tu voudrais faire la prochaine fois ?",
            answer: ""
          },
          {
            title:
              "Quel défi que as-tu réussi à mettre en place et dont tu es le plus fier ? Pourquoi ? Comment tu t’y es pris ?",
            answer: ""
          }
        ]
      },
      {
        sectionTitle: "II. QUESTIONS RELATIVES AU MOIS",
        questions: [
          {
            title:
              "Si tu avais un conseil à donner à l’équipe pour progresser en (variable max sélectionnée) ça serait quoi",
            answer: ""
          },
          {
            title:
              "Prendre note min sur confiance, stress, aisance , productivité et cohésion : Selon toi et dans l’objectif de faire progresser l’équipe, qu’est-ce qu’on pourrait mettre en place pour améliorer (variable min sélectionnée) ?",
            answer: ""
          }
        ]
      },
      {
        sectionTitle: "III. QUESTIONS FIXES POUR FAVORISER LA PROACTIVITE",
        questions: [
          {
            title:
              "Quelle est l’initiative pro-active dont tu es la plus fier de mois dernier ? Est-ce que tu peux m’en dire plus ?",
            answer: ""
          },
          {
            title:
              "Quels sont tes idées pour augmenter le ÇA ? Réduire les coûts ? Augmenter la productivité de l’équipe ? Réduire le process ? Comment tu penses qu’on pourrait faire mieux ? Quelle réunion pourrions-nous supprimer ?",
            answer: ""
          }
        ]
      },
      {
        sectionTitle: "IV. MANAGEURS COACHS",
        questions: [
          {
            title:
              "Qu’est-ce que tu as le plus en tête en ce moment ? Quels sont sont tes priorités? Comment tu comptes t’y prendre pour bien les gérer ?",
            answer: ""
          },
          {
            title:
              "Qu’est-ce que je peux faire pour t’aider ? Pour te faire gagner du temps ?",
            answer: ""
          }
        ]
      },
      {
        sectionTitle: "V. MOTIVATION ET SENS",
        questions: [
          {
            title:
              "Qu’est-ce que tu aimes dans ton travail ? Qu’est-ce que tu aimerais encore plus faire/plus souvent ?",
            answer: ""
          },
          {
            title:
              "Quels sont les projets que tu as le plus envie de faire ? pourquoi ?",
            answer: ""
          },
          {
            title:
              "Comment tu résumerais la mission que c’est donner l’entreprise ? (question sur le sens dans l’objectif de re-motiver)",
            answer: ""
          },
          {
            title: "Qu’est-ce que tu aimes moins faire ? Pourquoi ?",
            answer: ""
          },
          {
            title: "Quel serait l’idéal pour toi en matière d’organisation ?",
            answer: ""
          }
        ]
      }
    ]
  },
  managerComments: [{ comment: "Tres bonne idee !", date: moment(), user: "" }],
  userSelected: {
    firstName: "",
    lastName: "",
    picture: "",
    historical: [],
    data: [],
    goals: {
      leadership: 9,
      teamCohesion: 6,
      publicSpeaking: 4,
      proactivity: 3,
      resilience: 8,
      global: 15
    },
    stats: {
      stress: 0,
      confidence: 0,
      publicSpeaking: 0,
      teamCohesion: 0
    },
    feelingEvolution: [
      {
        mois: "septembre",
        Stress: 0,
        Confiance: 1,
        "Aisance à l'oral": -0.5,
        "Cohésion d'équipe": 2
      }
    ],
    feelingEvolutions: [
      {
        publicSpeaking: 2,
        teamCohesion: 1,
        confidence: 2,
        productivity: -2,
        stress: 1,
        mois: "octobre",
        monthNumber: 9,
        users: 10,
        date: moment().subtract(2, "month")
      },
      {
        publicSpeaking: 2,
        teamCohesion: 1,
        confidence: 2,
        productivity: -2,
        stress: 1,
        mois: "octobre",
        monthNumber: 8,
        users: 10,
        date: moment().subtract(1, "month")
      },
      {
        publicSpeaking: 2,
        teamCohesion: 1,
        confidence: 2,
        productivity: -2,
        stress: 1,
        mois: "octobre",
        monthNumber: 7,
        users: 10
      }
    ],
    totalDoneActions: 0
  },
  notificationTitle: "",
  notificationText: "",
  userComment: "",
  isSnackMessage: false,
  snackMessage: "",
  selectionList: [],
  selectedManagerNoteIndex: 0,
  managerTeam: [],
  requesting: false
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case MANAGER_SEND_NOTIFICATION_REQUESTING:
    case MANAGER_DELETE_SURVEY_REQUESTING:
    case MANAGER_CREATE_SURVEY_REQUESTING:
    case MANAGER_GET_SURVEYS_REQUESTING:
    case MANAGER_MODIFY_SURVEY_REQUESTING:
    case MANAGER_DELETE_COMMENT_REQUESTING:
    case MANAGER_SUBMIT_COMMENT_REQUESTING:
    case MANAGER_GET_TEAM_REQUESTING:
    case MANAGER_CREATE_TEAM_REQUESTING:
    case MANAGER_GET_DASHBOARD_REQUESTING: {
      return {
        ...state,
        requesting: true
      };
    }

    case MANAGER_SEE_USER_PROFILE_REQUESTING: {
      console.log("Warning resetting some states");
      const { managerSurveys, managerSurvey, userSelected } = initialState;
      return {
        ...state,
        managerSurveys,
        managerSurvey,
        userSelected,
        requesting: true
      };
    }

    case MANAGER_CHANGE_FIELD: {
      return {
        ...state,
        ...action.payload
      };
    }

    case MANAGER_GET_SURVEYS_SUCCESS: {
      return {
        ...state,
        requesting: false,
        selectedManagerNoteIndex: 0,
        // selectedManagerNoteIndex: action.payload.length
        //   ? action.payload.length - 1
        //   : 0,
        managerSurveys: action.payload
      };
    }

    case MANAGER_DELETE_SURVEY_SUCCESS: {
      console.log(action.payload.surveyId);
      const managerSurveys = state.managerSurveys.filter(
        el => el._id !== action.payload.surveyId
      );
      let selectedManagerNoteIndex = state.selectedManagerNoteIndex;
      if (selectedManagerNoteIndex > 0) {
        selectedManagerNoteIndex--;
      }
      const isCurrentSurvey =
        state.managerSurvey._id === action.payload.surveyId;
      const managerSurvey = isCurrentSurvey
        ? initialState.managerSurvey
        : state.managerSurvey;

      return {
        ...state,
        managerSurvey,
        requesting: false,
        isSnackMessage: true,
        selectedManagerNoteIndex,
        snackMessage: "Notes supprimées avec succès !",
        managerSurveys
      };
    }

    case MANAGER_CREATE_SURVEY_SUCCESS:
      return {
        ...state,
        requesting: false,
        managerSurvey: action.payload,
        isSnackMessage: true,
        snackMessage: "Notes sauvegardées avec succès !"
      };

    case MANAGER_MODIFY_SURVEY_SUCCESS:
      return {
        ...state,
        requesting: false,
        isSnackMessage: true,
        snackMessage: "Notes sauvegardées avec succès !"
      };

    case MANAGER_ON_EDIT_GOAL: {
      return {
        ...state,
        userSelected: {
          ...state.userSelected,
          goals: { ...state.userSelected.goals, ...action.payload }
        }
      };
    }

    case MANAGER_GET_DASHBOARD_SUCCESS: {
      return {
        ...state,
        requesting: false,
        ...action.payload
      };
    }

    case MANAGER_SUBMIT_COMMENT_SUCCESS: {
      return {
        ...state,
        isSnackMessage: true,
        snackMessage: "Commentaire sauvegardé !",
        requesting: false,
        userComment: ""
      };
    }

    case MANAGER_SEE_USER_PROFILE_SUCCESS: {
      return {
        ...state,
        requesting: false,
        userSelected: { ...state.userSelected, ...action.payload }
      };
    }

    case MANAGER_GET_TEAM_SUCCESS:
      return {
        ...state,
        requesting: false,
        selectionList: action.payload,
        managerTeam: action.payload
      };

    case MANAGER_CREATE_TEAM_SUCCESS:
      return {
        ...state,
        requesting: false,
        managerTeam: action.payload,
        isSnackMessage: true,
        snackMessage: "Équipe créée avec succès !"
      };

    case MANAGER_SELECT_TEAM_MEMBER: {
      const memberIndex = state.selectionList.findIndex(
        el => el === action.payload
      );
      let selectionList = [];
      let snackMessage = "";
      if (memberIndex > -1) {
        selectionList = state.selectionList.filter(el => el !== action.payload);
        snackMessage = "Membre retiré de l'équipe";
      } else {
        selectionList = [...state.selectionList, action.payload];
        snackMessage = "Membre ajouté à l'équipe !";
      }
      return {
        ...state,
        selectionList,
        isSnackMessage: true,
        snackMessage
      };
    }

    case MANAGER_GET_COMMENTS_SUCCESS: {
      return {
        ...state,
        requesting: false,
        managerComments: action.payload
      };
    }

    case MANAGER_SUBMIT_GOALS_SUCCESS:
      return {
        ...state,
        requesting: false,
        isSnackMessage: true,
        snackMessage: "Objectifs modifiés avec succès !"
      };

    case MANAGER_DELETE_COMMENT_SUCCESS: {
      let managerComments = state.managerComments.filter(
        el => el._id !== action.payload
      );
      return {
        ...state,
        isSnackMessage: true,
        snackMessage: "Commentaire supprimé",
        requesting: false,
        managerComments
      };
    }

    case MANAGER_SEND_NOTIFICATION_SUCCESS: {
      return {
        ...state,
        isSnackMessage: true,
        snackMessage: "Notification envoyée !",
        requesting: false,
        notificationTitle: "",
        notificationText: ""
      };
    }

    case MANAGER_SEND_NOTIFICATION_ERROR:
    case MANAGER_GET_DASHBOARD_ERROR:
    case MANAGER_MODIFY_SURVEY_ERROR:
    case MANAGER_DELETE_SURVEY_ERROR:
    case MANAGER_GET_SURVEYS_ERROR:
    case MANAGER_CREATE_SURVEY_ERROR:
    case MANAGER_SUBMIT_GOALS_ERROR:
    case MANAGER_DELETE_COMMENT_ERROR:
    case MANAGER_GET_COMMENTS_ERROR:
    case MANAGER_SUBMIT_COMMENT_ERROR:
    case MANAGER_SEE_USER_PROFILE_ERROR:
    case MANAGER_CREATE_TEAM_ERROR:
    case MANAGER_GET_TEAM_ERROR: {
      return { ...state, error: action.payload, requesting: false };
    }

    case MANAGER_CLOSE_SNACK_MESSAGE: {
      return { ...state, isSnackMessage: false };
    }

    case MANAGER_SELECT_TAB: {
      return { ...state, tabSelected: action.payload };
    }

    // case MANAGER_RESET_SELECTED_USER: {
    //   return { ...state, userSelected: initialState.userSelected };
    // }

    case AUTH_LOGOUT_SUCCESS: {
      return initialState;
    }

    default:
      return state;
  }
};

export default reducer;
